import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAlbum } from './useAlbums';
import { Spinner } from '@/components/Spinner';
import { Lightbox } from '@/features/albums/Lightbox';
import { BackHeader } from '@/components/BackHeader';

export function AlbumView() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useAlbum(id);
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  if (isLoading)
    return (
      <div className="py-8 text-center text-hint">
        <Spinner />
      </div>
    );
  if (!data) return <p className="text-hint text-sm py-6">Альбом не найден</p>;

  return (
    <div>
      <BackHeader title={data.title} />
      <ul className="grid grid-cols-3 gap-1">
        {data.photos.map((p, idx) => (
          <li key={p.id}>
            <button
              type="button"
              onClick={() => setOpenIdx(idx)}
              className="block w-full aspect-square overflow-hidden rounded-md bg-surface"
              aria-label={`Photo ${idx + 1}`}
            >
              <img src={p.url} alt="" className="w-full h-full object-cover" />
            </button>
          </li>
        ))}
      </ul>
      {openIdx !== null ? (
        <Lightbox
          images={data.photos.map((p) => p.url)}
          startIndex={openIdx}
          onClose={() => setOpenIdx(null)}
        />
      ) : null}
    </div>
  );
}
